import Marionette from 'backbone.marionette';
import memberCommitteesItemviewTmpl from '../templates/member_committees_itemview.tpl';
export default Marionette.ItemView.extend({
  tagName: "tr",
  template: memberCommitteesItemviewTmpl
});